<template>
<div v-loading="loading" class="container" >
  <el-row>
    <el-col :span="5" >
      <div>Compétences</div>
      <div>
        <el-select
          v-model="skills"
          :filterable="true"
          :remote="true"
          placeholder="Compétences"
          value-key="id"
          :clearable="true"
          :multiple="true"
          :remote-method="skillAutocomplete"
          :loading="skillLoading" >
          <el-option
            v-for="skill in skillSelection"
            :key="skill.id"
            :value="skill"
            :label="skill.label" />
        </el-select>
      </div>
    </el-col>
    <el-col :span="5" >
      <div>Zones d'emploi</div>
      <div>
        <el-select
          v-model="employmentZones"
          :filterable="true"
          :remote="true"
          placeholder="Zones d'emploi"
          value-key="id"
          :clearable="true"
          :multiple="true"
          :remote-method="employmentZoneAutocomplete"
          :loading="employmentZoneLoading" >
          <el-option
            v-for="employmentZone in employmentZoneSelection"
            :key="employmentZone.id"
            :value="employmentZone"
            :label="employmentZone.name" />
        </el-select>
      </div>
    </el-col>
    <el-col :span="5" >
      <div>Départements</div>
      <div>
        <el-select
          v-model="departments"
          :filterable="true"
          :remote="true"
          placeholder="Départements"
          value-key="id"
          :clearable="true"
          :multiple="true"
          :remote-method="departmentAutocomplete"
          :loading="departmentLoading" >
          <el-option
            v-for="department in departmentSelection"
            :key="department.id"
            :value="department"
            :label="department.name" />
        </el-select>
      </div>
    </el-col>
    <el-col :span="5" >
      <div>Régions</div>
      <div>
        <el-select
          v-model="regions"
          :filterable="true"
          :remote="true"
          placeholder="Régions"
          value-key="id"
          :clearable="true"
          :multiple="true"
          :remote-method="regionAutocomplete"
          :loading="regionLoading" >
          <el-option
            v-for="region in regionSelection"
            :key="region.id"
            :value="region"
          :label="region.name" />
      </el-select>
      </div>
    </el-col>
    <el-col :span="4" >
      <el-button type="primary" :disabled="skills.length < minSkills" @click="compute" >
        Calculer
      </el-button>
    </el-col>
  </el-row>
  <div v-if="!data.length" >
    Merci de sélectionner au moins {{ minSkills }} compétences.
  </div>
  <div v-else >
    <el-table :data="data" :stipe="true" >
      <el-table-column prop="trade.name" label="Métier" />
      <el-table-column prop="count" label="Occurences" />
      <el-table-column prop="score" label="Score" />
    </el-table>
  </div>
</div>
</template>

<script>
import { api } from '../../graphs/FeatureCache'

export default {
  props: {
    minSkills: {
      type: Number,
      default: 5
    },
    resultLimit: {
      type: Number,
      default: 50
    },
    sortBy: {
      type: String,
      default: 'score'
    },
    threshold: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      data: [],
      loading: false,
      skills: [],
      skillSelection: [],
      skillLoading: false,
      employmentZones: [],
      employmentZoneSelection: [],
      employmentZoneLoading: false,
      departments: [],
      departmentSelection: [],
      departmentLoading: false,
      regions: [],
      regionSelection: [],
      regionLoading: false
    }
  },
  methods: {
    compute () {
      this.loading = true
      api.post('/api/public/skill-trade', {
        skills: this.skills.map(s => s.id),
        employmentZones: this.employmentZones.map(ze => ze.id),
        departments: this.departments.map(d => d.id),
        regions: this.regions.map(r => r.id),
        limit: this.resultLimit,
        sort: this.sortBy,
        threshold: this.threshold
      }).then(({ data }) => {
        this.data.splice(0, this.data.length, ...data)
      }).finally(() => {
        this.loading = false
      })
    },
    skillAutocomplete (query) {
      this.skillLoading = true
      api.post('/crud/algo_skill', {
        filters: query.split(/\s+/).filter(f => f !== '').map(fragment => {
          return {
            type: 'App\\Model\\Filter\\LikeFilter',
            field: 'label',
            value: `"%${fragment}%"`
          }
        }),
        limit: 20
      }).then(({data}) => {
        this.skillSelection.splice(0, this.skillSelection.length, ...data.results)
      }).finally(() => {
        this.skillLoading = false
      })
    },
    employmentZoneAutocomplete (query) {
      this.employmentZoneLoading = true
      api.post('/crud/employment_zone', {
        filters: query.split(/\s+/).filter(f => f !== '').map(fragment => {
          return {
            type: 'App\\Model\\Filter\\LikeFilter',
            field: 'name',
            value: `"%${fragment}%"`
          }
        }),
        limit: 20
      }).then(({data}) => {
        this.employmentZoneSelection.splice(0, this.employmentZoneSelection.length, ...data.results)
      }).finally(() => {
        this.employmentZoneLoading = false
      })
    },
    departmentAutocomplete (query) {
      this.departmentLoading = true
      api.post('/crud/department', {
        filters: query.split(/\s+/).filter(f => f !== '').map(fragment => {
          return {
            type: 'App\\Model\\Filter\\LikeFilter',
            field: 'name',
            value: `"%${fragment}%"`
          }
        }),
        limit: 20
      }).then(({data}) => {
        this.departmentSelection.splice(0, this.departmentSelection.length, ...data.results)
      }).finally(() => {
        this.departmentLoading = false
      })
    },
    regionAutocomplete (query) {
      this.regionLoading = true
      api.post('/crud/region', {
        filters: query.split(/\s+/).filter(f => f !== '').map(fragment => {
          return {
            type: 'App\\Model\\Filter\\LikeFilter',
            field: 'name',
            value: `"%${fragment}%"`
          }
        }),
        limit: 20
      }).then(({data}) => {
        this.regionSelection.splice(0, this.regionSelection.length, ...data.results)
      }).finally(() => {
        this.regionLoading = false
      })
    }
  }
}
</script>

<style scoped>
.container {
    overflow: auto;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/macarons/components/TradeCompetenceWidget.vue